const UK = ["F", "G", "H", "I", "J½", "K½", "L½", "M½", "N½", "O½", "P½", "Q½", "R½", "S½", "T½", "U½", "V½", "W½", "Y", "Z", "Z+1"];

export const RING_SIZES = Array.from({ length: 21 }, (_, i) => {
  const us = 3 + i / 2;
  const d = 11.63 + 0.8128 * us;
  return { us, uk: UK[i], d: d.toFixed(1), eu: (Math.round(Math.PI * d * 2) / 2).toFixed(1) };
});
